import React from 'react';
import SVG from 'react-inlinesvg';
import helpIcon from '@lifesize/ux-assets/vectors/svgIcons/help.svg';
import classes from './Header.module.scss';

interface Props {
  desktopOpenHelp: Function;
  helpPageUrl: string;
  isDesktop: boolean;
}

const Help = (props: Props) => {
  const launchHelpPage = () => {
    if (props.isDesktop) {
      props.desktopOpenHelp(props.helpPageUrl);
    } else {
      window.open(props.helpPageUrl, '_blank');
    }
  };

  return (
    <button
      className={classes.helpButton}
      data-testid="help"
      onClick={launchHelpPage}
    >
      <SVG src={helpIcon} />
    </button>
  );
};

export default Help;
